/**
 * Подсказка о новой функции: видна человеку HINT_DAYS дней с его первого
 * открытия Ньютона после выката, а не с даты выката — вернувшийся из отпуска
 * через месяц получает свою неделю (решение владельца 12.10.2026).
 *
 * Отсчёт и закрытие хранятся в браузере: в другом браузере неделя начнётся
 * заново. `until` — общий предел: после него подсказку не видит никто, чтобы
 * «Новое» не висело вечно для тех, кто зарегистрируется позже.
 */
const DAY = 24 * 60 * 60 * 1000;

export const HINT_DAYS = 7;

export const HINTS = {
  // Папки Истории открыты всем 10.10.2026. Предел — примерно 60 дней после выката подсказки.
  folders: { until: '2026-12-12T00:00:00+03:00' },
};

const key = (name) => `newton.hint.${name}`;

// Состояние подсказки; null — хранилище недоступно (приватный режим, запрет).
function read(name) {
  let raw;
  try { raw = localStorage.getItem(key(name)); } catch { return null; }
  try {
    const saved = JSON.parse(raw || '{}');
    return saved && typeof saved === 'object' ? saved : {};
  } catch { return {}; }
}

function write(name, state) {
  try { localStorage.setItem(key(name), JSON.stringify(state)); return true; } catch { return false; }
}

/** Показывать ли подсказку сейчас. Первый вызов начинает отсчёт человека. */
export function hintVisible(name, now = Date.now()) {
  const hint = HINTS[name];
  // Кривая дата даёт NaN, а `now >= NaN` ложно — без проверки подсказка стала бы бессрочной.
  const until = hint ? Date.parse(hint.until) : NaN;
  if (!Number.isFinite(until) || now >= until) return false;
  const state = read(name);
  if (!state || state.done) return false;
  if (typeof state.first !== 'number') {
    // Отсчёт не записался — не показываем вовсе: иначе подсказка бессрочна.
    return write(name, { ...state, first: now });
  }
  return now - state.first < HINT_DAYS * DAY;
}

/** Человек закрыл подсказку или воспользовался функцией — больше не показывать. */
export function dismissHint(name) {
  const state = read(name);
  if (state && !state.done) write(name, { ...state, done: true });
}

/** true ровно один раз — при первом показе; по нему пишется событие «увидел». */
export function markShown(name) {
  const state = read(name);
  if (!state || state.shown) return false;
  return write(name, { ...state, shown: true });
}
